import { render, staticRenderFns } from "./subjectFeedback.vue?vue&type=template&id=6bd51c28&"
import script from "./subjectFeedback.vue?vue&type=script&lang=js&"
export * from "./subjectFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports